import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { RestResponse as RestResponseGeneric } from 'app/modules/common/entities/rest.response-generic.model';
import API from '../../../modules/common/services/api.config.json';
import { ApiService } from 'app/modules/common/services/api.service';
import { DropDownOption } from 'app/modules/common/types/dropdown-option.type';


@Injectable({
    providedIn: 'root'
})
export class CoordinatorsService {

    constructor(private apiService: ApiService) { }


    GetAllCoordinatorsList(): Observable<RestResponse> {
        let url = `${API.Coordinator.getAllCoordinatorsList}`;
        //url = url.replace('{doctorId}', doctorId).replace('{companyId}', companyId);
        return this.apiService.get(url);
    }
    AddCoordinators(Coordinador: any): Observable<RestResponse> {
        let url = `${API.Coordinator.addCoordinators}`;
        return this.apiService.post(url, Coordinador);
    }
    GetDespachoC(Coordinador: any, Year: any): Observable<RestResponse> {
        let url = `${API.Coordinator.getDespachoC}`;
        url = url.replace('{coordinator}', Coordinador).replace('{year}', Year);
        return this.apiService.get(url);
    }
    UpdateCoordinators(Coordinador: any): Observable<RestResponse> {
        let url = `${API.Coordinator.updateCoordinators}`;
        return this.apiService.put(url, Coordinador);
    }
    GetSpecificCoordinators(CoordinadorId: number): Observable<RestResponse> {
        let url = `${API.Coordinator.getSpecificCoordinators}`;
        url = url.replace('{coordinator}', CoordinadorId.toString());
        return this.apiService.get(url);
    }
    DeleteSpecificCoordinators(CoordinadorId: number): Observable<RestResponse> {
        let url = `${API.Coordinator.deleteSpecificCoordinators}`;
        url = url.replace('{coordinator}', CoordinadorId.toString());
        return this.apiService.delete(url);
    }
    AddDespacho(DespachoC: any): Observable<RestResponse> {
        let url = `${API.Coordinator.addDespacho}`;
        return this.apiService.post(url, DespachoC);
    }
    EditDespacho(DespachoC: any): Observable<RestResponse> {
        let url = `${API.Coordinator.editDespacho}`;
        return this.apiService.put(url, DespachoC);
    }
    DeleteDespacho(id: any): Observable<RestResponse> {
        let url = `${API.Coordinator.deleteDespacho}`;
        url = url.replace('{id}', id.toString());
        return this.apiService.delete(url);
    }


    /**
     * Get active coordinators
     */
    GetActiveCoordinators(): Observable<RestResponseGeneric<DropDownOption<number>[]>> {
        const url = `${API.Coordinator.getActiveCoordinator}`;
        return this.apiService.get(url);
    }

}
